import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { jobArchitectureKeys } from '../job-architecture-v2';

export const useInvalidateLearningOpportunityRelatedCaches = (): (() => void) => {
    const queryClient = useQueryClient();

    return useCallback(() => {
        queryClient.invalidateQueries({ queryKey: jobArchitectureKeys.skillCatalog() });
    }, [queryClient]);
};
